import { WorkspaceRoles } from '@/enums';
import { useUser } from '@/hooks/useUser';
import useGetCurrentWorkspace from './useGetCurrentWorkspace';

const useWorkspaceRoles = () => {
  const { user } = useUser();
  const currentWorkspace = useGetCurrentWorkspace();
  const { members } = currentWorkspace || {};
  // Find current user in members array - members already have role information
  const currentUserMember = members?.find(({ user_id }) => user_id === user?._id);
  const userRole = currentUserMember?.role;

  // Simple role checks based on the role already in the member data
  const isUserOwner = userRole === WorkspaceRoles.OWNER;
  const isUserEditor = userRole === WorkspaceRoles.EDITOR;
  const isUserViewer = userRole === WorkspaceRoles.VIEWER;

  return {
    isUserOwner,
    isUserEditor,
    isUserViewer,
  };
};

export default useWorkspaceRoles;
